import { useEffect } from "react";
import { oneTrustCookieScriptLoad } from "./oneTrustCookies";
import { useJsCramblerScript } from "./useJsCramblerScript";
import { useFeatureValue } from "@growthbook/growthbook-react";
import { GROWTHBOOK_FEATURES_KEYS } from "../growthBook/features";

export const ScriptsLoader = ({ children }) => {
  useJsCramblerScript();
  const cookiesPopUpEnabledInApps = useFeatureValue(GROWTHBOOK_FEATURES_KEYS.COOKIES_CONSENT_ENABLED_APPS, false);
  const loadScripts = async () => {
    await oneTrustCookieScriptLoad(cookiesPopUpEnabledInApps);
  };

  useEffect(() => {
    loadScripts()
  }, [cookiesPopUpEnabledInApps]);


  return children;
};
